import { CALL_STATE } from 'Constants/enums';
import { MobXProviderContext, observer } from 'mobx-react';
import { useCallRouter } from 'Modules/softphone/hooks';
import * as React from 'react';
import { Loader, Popup } from 'semantic-ui-react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { pushToGTMDataLayer } from 'Utils/analytics';
import { StartCallButton } from './StartCallButton';
import { ActivityItemPhoneVideoButtonsProps } from './types';

const ActivityItemPhoneVideoButtonsObservable: React.FC<
  ActivityItemPhoneVideoButtonsProps
> = ({
  buttonSize: size,
  compact,
  conversation,
  currentPersonId,
  from,
  grouping,
  personPbo,
  phone,
  popupPosition = 'bottom right',
}) => {
  const {
    person: personStore,
    phoneCall: phoneStore,
    ui: { selectPersonMessageStatus },
  } = React.useContext<RootStoreProps>(MobXProviderContext);

  const { callWithPerson } = useCallRouter();

  const testid = 'activityItemPhoneVideoButtons';
  const [callState, setCallState] = React.useState<CALL_STATE>(
    CALL_STATE.Available
  );

  React.useEffect(() => {
    phoneStore.phoneCalls.filter(({ isCallConnecting, callUri }) => {
      const updatedCallState = isCallConnecting
        ? CALL_STATE.Connecting
        : CALL_STATE.Connected;

      if (personPbo?.state === 'fulfilled') {
        const elementPR = callUri?.split('@')[0].substring(2);
        if (elementPR === String(personPbo?.value.sourceId || 0)) {
          setCallState(updatedCallState);
        }
      }
      if (!personPbo && phone === callUri?.split('@')[0]) {
        setCallState(updatedCallState);
      }
    });
  }, [phoneStore.phoneCalls, personPbo, phone]);

  const isGroupChat = grouping === 'Channel' || grouping === 'Group';

  /* ------------------ IS NOT A COMMUNICATOR USER ----------------- */
  /* -------------------------------------------------------------- */
  if (!personPbo) {
    void personStore.getAllContactsWithSameNum(phone);
    return (
      <div className="semantic-flex-row">
        {/*   ----- CALL BUTTON -----
         Never hidden for non-communicator users (they always have a phone number) */}
        {!isGroupChat && (
          <StartCallButton
            {...{
              compact,
              size,
              popupPosition,
              callState,
              personPbo,
              phone,
              currentPersonId,
              makeCall: (personId?: number, phone?: string) => {
                void callWithPerson(personId?.toString(), phone);
              },
              pushToGTMDataLayer,
              conversationId: conversation?.id,
              testid,
            }}
          />
        )}
      </div>
    );
  }
  /* ------------------ COMMUNICATOR USER OR GROUP ----------------- */
  /* -------------------------------------------------------------- */
  return personPbo.case({
    pending: () => <Loader active inline />,
    rejected: (reason) => <span>{reason?.response?.data?.message}</span>,
    fulfilled: () => {
      return (
        <div className="semantic-flex-row semantic-flex-align-items-center">
          {currentPersonId && from !== 'group-info' && (
            <Popup
              inverted
              trigger={
                <span className="message-status">
                  {selectPersonMessageStatus(currentPersonId)?.title || ''}
                </span>
              }
              content={
                selectPersonMessageStatus(currentPersonId)?.message || ''
              }
              position="top right"
            />
          )}
          {!isGroupChat && (
            <StartCallButton
              {...{
                compact,
                size,
                popupPosition,
                callState,
                personPbo,
                phone,
                currentPersonId,
                makeCall: (personId?: number, phone?: string) => {
                  void callWithPerson(personId?.toString(), phone);
                },
                pushToGTMDataLayer,
                conversationId: conversation?.id,
                testid,
              }}
            />
          )}
        </div>
      );
    },
  });
};

export const ActivityItemPhoneVideoButtons = observer(
  ActivityItemPhoneVideoButtonsObservable
);
